import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react';
import { RosadoPromo } from './RosadoPromo';
import { NegroPromo } from './NegroPromo';
const KIT_NEGRO_URL = 'https://e04whn-0h.myshopify.com/products/kit-negro-premium-para-extensiones-de-pestanas';
const KIT_ROSADO_URL = 'https://e04whn-0h.myshopify.com/products/kit-rosado-premium-para-extensiones-de-pestanas';
export function Products() {
  const [expandedRosado, setExpandedRosado] = useState(false);
  const [expandedNegro, setExpandedNegro] = useState(false);
  const [rosadoImageIndex, setRosadoImageIndex] = useState(0);
  const [negroImageIndex, setNegroImageIndex] = useState(0);
  const rosadoImages = ['https://cdn.magicpatterns.com/uploads/wq6YXJAr6hdYgGtddAmQq2/ChatGPT_Image_20_abr_2026,_20_08_07.png', 'https://cdn.magicpatterns.com/uploads/fWALG8H619iKDk6xyKSDsJ/d6f6b1d7-7906-4849-9b0b-dc5ea9cc688d.jpg', 'https://cdn.magicpatterns.com/uploads/uPfBUfT2hUtyDL8fWtXdWE/ChatGPT_Image_20_abr_2026,_20_07_24.png', 'https://cdn.magicpatterns.com/uploads/7W27e3K4woAXVtoifegPKg/4497e3b6-c0e6-4929-acb0-fe381dad099e.jpg', 'https://cdn.magicpatterns.com/uploads/8ysrASFbWq8yb2Zw8e4wVz/92520652-d6ae-41d4-a9b7-bc6974ef76e5.jpg', 'https://cdn.magicpatterns.com/uploads/wtyLJRm6gaTAuHmKCZaKjf/0D8CC461-27A2-4BAA-BC23-CABB4DFA6045.png'];
  const negroImages = ['https://cdn.magicpatterns.com/uploads/7yFwuHrde9f4MrWQZW9sUK/ChatGPT_Image_20_abr_2026,_20_08_20.png', 'https://cdn.magicpatterns.com/uploads/hrhNm58zU1nucXYAfoSFMa/ChatGPT_Image_20_abr_2026,_20_04_57.png', 'https://cdn.magicpatterns.com/uploads/xoVRRCVj4e1ur15p81n3bi/110A8423-A3E2-411B-83EE-B09C7DD1FBDA_(1).png', 'https://cdn.magicpatterns.com/uploads/tsV5i4YR5v7GKqnbdcoe2p/fa2f9a63-2c6d-44b6-aa45-3fdf25e9746a.jpg', 'https://cdn.magicpatterns.com/uploads/7Nnr2e2uuGKDNHDsGGZ61U/6e02a688-b463-4266-931d-04d88ee12b51.jpg'];
  return <section className="pt-10 pb-16 sm:pt-14 sm:pb-20 lg:pt-16 lg:pb-24 px-5 sm:px-6 bg-white" id="products" data-id="element-244" data-mp="2p8lvddrb81dg">
      <div className="max-w-6xl mx-auto" data-id="element-245" data-mp="2l7s3k9aqy2fa">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 sm:mb-14" data-id="element-246" data-mp="2l4w94uy3xvvl">
          <h2 className="text-3xl md:text-4xl font-serif text-luxury-black mb-4" data-id="element-247" data-mp="21hy8nmcqj76u">
            ELIGE TU FAVORITO
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-248" data-mp="1xf1waddsg7bc"></div>
        </motion.div>

        <div className="flex flex-col gap-12 lg:gap-16" data-id="element-249" data-mp="1sjmkrs396ni3">
          {/* KIT ROSADO — PROTAGONISTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="group relative bg-rosado-soft rounded-2xl p-8 md:p-12 border border-rosado-light/30 hover:shadow-xl transition-shadow duration-500 flex flex-col max-w-2xl mx-auto w-full" data-id="element-250" data-mp="1nigt7xlbx6a5">
            <div className="absolute top-6 right-6 bg-white text-rosado font-bold text-xs tracking-wider uppercase px-3 py-1.5 rounded-full shadow-sm flex items-center gap-1 z-10" data-id="element-251" data-mp="pq8o7017nhnn">
              🔥 MÁS VENDIDO
            </div>

            {/* Image Gallery */}
            <div className="relative aspect-[3/2] sm:aspect-[4/3] bg-white rounded-xl mb-6 overflow-hidden -mx-2 md:-mx-4" data-id="element-252" data-mp="zlsglcgkfy7n">
              <a href={KIT_ROSADO_URL} target="_blank" rel="noopener noreferrer" aria-label="Comprar Kit Rosado Premium" className="block w-full h-full" data-id="element-253" data-mp="6zhj4ao9adf2">
                <img src={rosadoImages[rosadoImageIndex]} alt="Kit Rosado Premium" loading="eager" decoding="async" className="w-full h-full object-cover transition-opacity duration-300" style={{
                imageRendering: 'auto',
                WebkitBackfaceVisibility: 'hidden'
              }} data-id="element-254" data-mp="2dnhvjyp04vxb" />
              </a>
              {/* Navigation arrows */}
              <button onClick={() => setRosadoImageIndex(prev => prev === 0 ? rosadoImages.length - 1 : prev - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-sm transition-colors" data-id="element-255" data-mp="2sbuun4jdyuw1">
                <ChevronLeft className="w-4 h-4 text-luxury-black" data-id="element-256" data-mp="170mbrqrkix6h" />
              </button>
              <button onClick={() => setRosadoImageIndex(prev => prev === rosadoImages.length - 1 ? 0 : prev + 1)} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-white/80 hover:bg-white rounded-full flex items-center justify-center shadow-sm transition-colors" data-id="element-257" data-mp="3imn2craz1jgs">
                <ChevronRight className="w-4 h-4 text-luxury-black" data-id="element-258" data-mp="2zuc5pf6wuhr4" />
              </button>
              {/* Dots */}
              <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5" data-id="element-259" data-mp="34sdqc4jzip4p">
                {rosadoImages.map((_, i) => <button key={i} onClick={() => setRosadoImageIndex(i)} className={`w-2 h-2 rounded-full transition-colors ${i === rosadoImageIndex ? 'bg-rosado' : 'bg-white/60'}`} data-id="element-260" data-mp="2uvr69hzhg23q" data-mpi={i} />)}
              </div>
            </div>

            <h3 className="text-2xl font-serif text-luxury-black mb-3" data-id="element-261" data-mp="rotjlbbgluqk">
              <a href={KIT_ROSADO_URL} target="_blank" rel="noopener noreferrer" data-id="element-262" data-mp="moe6mkv3ap94">
                KIT ROSADO PREMIUM
              </a>
            </h3>
            <p className="text-gray-600 font-sans font-light mb-6" data-id="element-263" data-mp="dp0t9h3uhgj4">
              Elegancia, organización y estilo en un solo beauty kit diseñado
              para mujeres que aman verse profesionales siempre.
            </p>

            <ul className="space-y-2.5 mb-6" data-id="element-264" data-mp="15fykshuh6v30">
              {['Fácil de usar', 'Compacto y portátil', 'Ideal para citas, estudio o viajes', 'Perfecto para profesionales y principiantes', 'Diseño femenino y sofisticado', 'Acabado premium elegante'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-700" data-id="element-265" data-mp="1odhod5y5zli1" data-mpi={i}>
                  <Check className="w-5 h-5 text-rosado shrink-0" data-id="element-266" data-mp="373drd1n22qa0" />
                  <span data-id="element-267" data-mp="3c0npr6sfac9z">{item}</span>
                </li>)}
            </ul>

            <p className="font-serif italic text-luxury-black text-center mb-6 text-sm" data-id="element-268" data-mp="3g0xvqjg7t2ou">
              Todo en orden. Todo contigo.
            </p>

            <a href={KIT_ROSADO_URL} target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-rosado hover:bg-rosado-light text-white font-sans font-medium tracking-widest uppercase py-4 rounded-sm transition-colors duration-300" data-id="element-269" data-mp="3pzwvfcj05nzp">
              COMPRAR KIT ROSADO
            </a>

            <p className="text-center text-xs text-gray-400 mt-3 tracking-wide" data-id="element-270" data-mp="7l4hkb9cw3ay">
              ✨ Ideal para regalar
            </p>

            <button onClick={() => setExpandedRosado(!expandedRosado)} className="mt-6 flex items-center justify-center gap-2 w-full text-sm font-medium text-gray-500 hover:text-rosado transition-colors uppercase tracking-wider" data-id="element-271" data-mp="hjtxhyhozdok">
              {expandedRosado ? 'Ocultar detalles' : 'Ver detalles'}
              <motion.div animate={{
              rotate: expandedRosado ? 180 : 0
            }} data-id="element-272" data-mp="1gbep1y4zfgk">
                <ChevronDown className="w-4 h-4" data-id="element-273" data-mp="3tjkp7e94bfql" />
              </motion.div>
            </button>

            <AnimatePresence data-id="element-274" data-mp="35tgigy0muzvd">
              {expandedRosado && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.4,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-275" data-mp="30yb18ci6e9dm">
                  <div className="pt-8 mt-6 border-t border-rosado-light/30" data-id="element-276" data-mp="2ctjvaib7nhpp">
                    <h4 className="font-serif text-lg text-luxury-black mb-4" data-id="element-277" data-mp="1y45kr6vweu8q">
                      TU ESENCIAL DE BELLEZA, ORGANIZADO CON ESTILO
                    </h4>

                    <div className="space-y-4 text-sm text-gray-600 font-light mb-8" data-id="element-278" data-mp="2314azecfyh1n">
                      <p data-id="element-279" data-mp="2qtciw4rfxhtg">
                        Diseñado para mujeres que aman los detalles, la
                        organización y una imagen impecable. Este beauty travel
                        kit combina elegancia, practicidad y comodidad para
                        acompañarte a donde vayas.
                      </p>
                      <p data-id="element-280" data-mp="15fgdsr85vup2">
                        Ideal tanto para profesionales como para principiantes
                        que desean tener sus herramientas siempre listas y en
                        orden.
                      </p>
                    </div>

                    <div className="mb-8" data-id="element-281" data-mp="3iqah8fuiop4h">
                      <h5 className="text-xs font-bold tracking-widest uppercase text-rosado mb-4" data-id="element-282" data-mp="3nols8twjt5oa">
                        DETALLES DEL PRODUCTO:
                      </h5>
                      <ul className="space-y-2 pl-1" data-id="element-283" data-mp="38xwd5gfyv6f5">
                        {['Incluye 8 esenciales beauty items', 'Tono universal', 'No sensible al calor', 'Libre de crueldad animal', 'No caduca', 'Presentación tipo estuche / kit / cosmetiquera'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-284" data-mp="2v194igenirte" data-mpi={i}>
                            <span className="w-1.5 h-1.5 rounded-full bg-rosado shrink-0 mt-1.5" data-id="element-285" data-mp="t9csl5oknfy3"></span>
                            <span data-id="element-286" data-mp="2dqc5mrt5fm5i">{item}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div className="mb-8 bg-white/60 p-4 rounded-lg border border-rosado-light/20" data-id="element-287" data-mp="28ppnfpmt7kzz">
                      <p className="text-xs font-bold uppercase text-luxury-black mb-1" data-id="element-288" data-mp="2nirri07kguvo">
                        IMPORTANTE:
                      </p>
                      <p className="text-sm text-gray-600" data-id="element-289" data-mp="2wgliqwqh4ybz">
                        Solo para uso externo.
                      </p>
                    </div>

                    <a href={KIT_ROSADO_URL} target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-luxury-black hover:bg-luxury-dark text-white font-sans font-medium tracking-widest uppercase py-4 rounded-sm transition-colors duration-300 mb-6" data-id="element-290" data-mp="2si4fioa6c7zu">
                      COMPRAR KIT ROSADO
                    </a>

                    <p className="text-center font-serif italic text-gray-500 text-sm" data-id="element-291" data-mp="375py6e64i20s">
                      Femenino, elegante y práctico para acompañarte siempre.
                    </p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>

          {/* Rosado Promo Section */}
          <RosadoPromo data-id="element-292" data-mp="3l23914g5j56a" />

          {/* Separator */}
          <div className="flex items-center gap-4 max-w-xs mx-auto" data-id="element-293" data-mp="3q2r7ucamgqb2">
            <div className="flex-1 h-px bg-gray-200" data-id="element-294" data-mp="3v23t4sluhpbj"></div>
            <span className="text-xs tracking-[0.2em] uppercase text-gray-400 font-medium" data-id="element-295" data-mp="3v0izr6b9ocf9">
              o elige
            </span>
            <div className="flex-1 h-px bg-gray-200" data-id="element-296" data-mp="7pb8x0zs955a"></div>
          </div>

          {/* KIT NEGRO — ALTERNATIVA PREMIUM */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="group relative bg-luxury-black text-white rounded-2xl p-8 md:p-12 border border-luxury-dark hover:shadow-2xl transition-shadow duration-500 flex flex-col max-w-2xl mx-auto w-full" data-id="element-297" data-mp="cpp7ztjep4r6">
            <div className="absolute top-6 right-6 bg-gold text-luxury-black font-bold text-xs tracking-wider uppercase px-3 py-1.5 rounded-full shadow-sm flex items-center gap-1 z-10" data-id="element-298" data-mp="1ahvuugzqx1cb">
              💎 PREMIUM QUALITY
            </div>

            {/* Image Gallery */}
            <div className="relative aspect-[3/2] sm:aspect-[4/3] bg-luxury-dark/50 rounded-xl mb-6 -mx-2 md:-mx-4 overflow-hidden" data-id="element-299" data-mp="10q9fc8gdkg3r">
              <a href={KIT_NEGRO_URL} target="_blank" rel="noopener noreferrer" aria-label="Comprar Kit Negro Luxury" className="block w-full h-full" data-id="element-300" data-mp="1t96kkutqj82m">
                <img src={negroImages[negroImageIndex]} alt="Kit Negro Luxury" loading="eager" decoding="async" className="w-full h-full object-cover transition-opacity duration-300" style={{
                imageRendering: 'auto',
                WebkitBackfaceVisibility: 'hidden'
              }} data-id="element-301" data-mp="18ylufy9c46za" />
              </a>
              <button onClick={() => setNegroImageIndex(prev => prev === 0 ? negroImages.length - 1 : prev - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-black/60 hover:bg-black/80 rounded-full flex items-center justify-center shadow-sm transition-colors" data-id="element-302" data-mp="1wq14kd7crsl3">
                <ChevronLeft className="w-4 h-4 text-white" data-id="element-303" data-mp="2fg8zi80wfcq7" />
              </button>
              <button onClick={() => setNegroImageIndex(prev => prev === negroImages.length - 1 ? 0 : prev + 1)} className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 bg-black/60 hover:bg-black/80 rounded-full flex items-center justify-center shadow-sm transition-colors" data-id="element-304" data-mp="40qjdo6qwfja">
                <ChevronRight className="w-4 h-4 text-white" data-id="element-305" data-mp="3h70i00fue0t1" />
              </button>
              <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5" data-id="element-306" data-mp="3c8p6ll9wfi8p">
                {negroImages.map((_, i) => <button key={i} onClick={() => setNegroImageIndex(i)} className={`w-2 h-2 rounded-full transition-colors ${i === negroImageIndex ? 'bg-gold' : 'bg-white/40'}`} data-id="element-307" data-mp="3r6rf89vsetwt" data-mpi={i} />)}
              </div>
            </div>

            <h3 className="text-2xl font-serif text-white mb-3" data-id="element-308" data-mp="11fw3dmue4yos">
              <a href={KIT_NEGRO_URL} target="_blank" rel="noopener noreferrer" data-id="element-309" data-mp="18k42avlc4tm9">
                KIT NEGRO LUXURY
              </a>
            </h3>
            <p className="text-gray-300 font-sans font-light mb-6" data-id="element-310" data-mp="1iitj0l1hw80x">
              Organizado. Elegante. Profesional. El beauty kit diseñado para
              mujeres que buscan proyectar una imagen impecable, mantener todo
              en orden y llevar su estilo al siguiente nivel.
            </p>

            <ul className="space-y-2.5 mb-6" data-id="element-311" data-mp="ut8wjs64usmw">
              {['Todo en su lugar y fácil acceso', 'Diseño elegante y profesional', 'Ideal para citas, trabajo o viajes', 'Herramientas esenciales incluidas', 'Compacto, práctico y funcional', 'Perfecto para profesionales y principiantes'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-312" data-mp="c05244l3cbr8" data-mpi={i}>
                  <Check className="w-5 h-5 text-gold shrink-0" data-id="element-313" data-mp="2lae3vje2i3gi" />
                  <span data-id="element-314" data-mp="2lb5pc1dyakt2">{item}</span>
                </li>)}
            </ul>

            <p className="font-serif italic text-white text-center mb-6 text-sm" data-id="element-315" data-mp="2g9q68evc2odb">
              No es solo un kit. Es la forma profesional de llevar contigo todo
              lo que necesitas.
            </p>

            <a href={KIT_NEGRO_URL} target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-gold hover:bg-gold-dark text-luxury-black font-sans font-bold tracking-widest uppercase py-4 rounded-sm transition-colors duration-300" data-id="element-316" data-mp="26ees9yrr1l6m">
              COMPRAR KIT NEGRO
            </a>

            <p className="text-center text-xs text-gray-400 mt-3 tracking-wide" data-id="element-317" data-mp="1nlasrwruoe43">
              ✨ Diseñado para mujeres que quieren verse y sentirse
              profesionales en todo momento.
            </p>

            <button onClick={() => setExpandedNegro(!expandedNegro)} className="mt-6 flex items-center justify-center gap-2 w-full text-sm font-medium text-gray-400 hover:text-gold transition-colors uppercase tracking-wider" data-id="element-318" data-mp="37i87rokbp7le">
              {expandedNegro ? 'Ocultar detalles' : 'Ver detalles'}
              <motion.div animate={{
              rotate: expandedNegro ? 180 : 0
            }} data-id="element-319" data-mp="32kgdinw7h9e1">
                <ChevronDown className="w-4 h-4" data-id="element-320" data-mp="2slhhc4smn67x" />
              </motion.div>
            </button>

            <AnimatePresence data-id="element-321" data-mp="2etuajb126faw">
              {expandedNegro && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.4,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-322" data-mp="2js5jljjj4ls2">
                  <div className="pt-8 mt-6 border-t border-gray-800" data-id="element-323" data-mp="207x3ib53xjqk">
                    <h4 className="font-serif text-lg text-white mb-4" data-id="element-324" data-mp="1v67suwlsr830">
                      ELEGANCIA PROFESIONAL EN CADA DETALLE
                    </h4>

                    <div className="space-y-4 text-sm text-gray-300 font-light mb-8" data-id="element-325" data-mp="255f6lkwg14qn">
                      <p data-id="element-326" data-mp="253cfsyngv7kv">
                        Pensado para mujeres y profesionales que buscan
                        presencia, orden y sofisticación. Este kit premium
                        ofrece funcionalidad total en un diseño moderno y
                        elegante.
                      </p>
                      <p data-id="element-327" data-mp="2ssn95v2hlzoz">
                        Perfecto para quienes desean proyectar una imagen
                        profesional mientras mantienen todo organizado.
                      </p>
                    </div>

                    <div className="mb-8" data-id="element-328" data-mp="2vg39nj0blawg">
                      <h5 className="text-xs font-bold tracking-widest uppercase text-gold mb-4" data-id="element-329" data-mp="2vf1wn8zquec3">
                        DETALLES DEL PRODUCTO:
                      </h5>
                      <ul className="space-y-2 pl-1" data-id="element-330" data-mp="35esu9jjlp9ge">
                        {['Incluye 8 esenciales cuidadosamente seleccionados', 'Organización inteligente para trabajar con mayor rapidez', 'Diseño pensado para elevar tu imagen profesional', 'Ideal para uso personal o en servicios de belleza', 'Material resistente que protege cada herramienta', 'Estuche premium con acabado elegante y duradero'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-300" data-id="element-331" data-mp="1txjep83lf1kd" data-mpi={i}>
                            <span className="w-1.5 h-1.5 rounded-full bg-gold shrink-0 mt-1.5" data-id="element-332" data-mp="1olvywpan04mb"></span>
                            <span data-id="element-333" data-mp="19x9be0auw6k0">{item}</span>
                          </li>)}
                      </ul>
                    </div>

                    <div className="mb-8 bg-luxury-dark/50 p-4 rounded-lg border border-gray-800" data-id="element-334" data-mp="1etgm06e7668a">
                      <p className="text-xs font-bold uppercase text-gold mb-1" data-id="element-335" data-mp="22j2l6tukklga">
                        IMPORTANTE:
                      </p>
                      <p className="text-sm text-gray-300" data-id="element-336" data-mp="1snr2k0g1iu39">
                        Solo para uso externo.
                      </p>
                    </div>

                    <a href={KIT_NEGRO_URL} target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-gold hover:bg-gold-dark text-luxury-black font-sans font-bold tracking-widest uppercase py-4 rounded-sm transition-colors duration-300 mb-6" data-id="element-337" data-mp="1xnvjfrkv1qu0">
                      COMPRAR KIT NEGRO
                    </a>

                    <p className="text-center font-serif italic text-gray-400 text-sm" data-id="element-338" data-mp="2f2zfcr0po4r4">
                      Sofisticado, práctico y diseñado para destacar.
                    </p>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>

          {/* Negro Promo Section */}
          <NegroPromo data-id="element-339" data-mp="212onplrkum4w" />
        </div>
      </div>
    </section>;
}